import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    devices:[],
    loading: false,
}

const deviceSlice = createSlice({
  name: "device",
  initialState: initialState,
  reducers: {
    setdevices(state, value) {
      state.devices = value.payload;
    },
    setLoading(state, value) {
      state.loading = value.payload;
    }
  },
});

export const { setdevices, setLoading} = deviceSlice.actions;

export default deviceSlice.reducer;